import {Component, OnDestroy, OnInit} from "@angular/core";
import {RoleService} from "../../app/core/role.service";
import {ModalController} from "ionic-angular";
import {ContractModal} from "../../app/components/contract-modal/contract-modal.component";
import {ContractService} from "../../app/core/contract.service";
/*
 Generated class for the SignupPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  templateUrl: 'signup.page.html'
})
export class SignupPage implements OnInit, OnDestroy {
  role: string = null;
  roleSub: any;

  constructor(private roleService: RoleService, private modalCtrl: ModalController, private contractService: ContractService){
  }

  ngOnInit(): void {
    this.roleSub = this.roleService.getRole()
      .subscribe((role) => this.role = role);
  }
  ngOnDestroy(): void {
    this.roleSub.unsubscribe();
  }

  ionViewWillEnter(){
    this.contractService.latest('privacy')
      .subscribe(contract => {
        this.modalCtrl
          .create(
            ContractModal,
            {contract: contract, signature: false},
            {enableBackdropDismiss: false}
          )
          .present();
      });
  }
  updateRole(role){
    this.roleService.setRole(role);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.page.ts